import styled from '@emotion/styled';
import React, { FC } from 'react';
import { useStorage } from '~Components/Storage';
import { useButton, useI18n, useSelector } from '~Hooks';
import { TransparentButton } from '~Styles';

const Wrapper = styled(TransparentButton)<{ active?: boolean }>`
  padding: 0;
  text-decoration: ${(props) => (props.active ? 'none' : 'underline')};
  text-transform: none;
  color: ${(props) => (props.active ? 'var(--colorWhite)' : 'var(--colorBlueGray200)')};
`;

interface Props {
  children: string;
  langKey: string;
}

const LangButton: FC<Props> = ({ children, langKey }) => {
  const [storage] = useStorage();
  const locale = useSelector((state) => state.locale);
  const { changeLanguage } = useI18n();

  const langToCompare = storage.selectedLanguage || locale;

  const langBtn = useButton({
    onClick: () => changeLanguage(langKey),
  });

  return (
    <Wrapper size="small" {...langBtn} active={langToCompare === langKey}>
      {children}
    </Wrapper>
  );
};

export default LangButton;
